// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__yLNt_","header":"Messages_header__1COgQ"};